export default __webpack_public_path__ + "static/media/emoji-instagram.86b8df7f.svg";